// extracted by mini-css-extract-plugin
module.exports = {"capacitiesheight":"7rem"};